import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function GoalsSection() {
  const goals = [{
    emoji: '🧠',
    text: 'Desarrollar una mentalidad de crecimiento'
  }, {
    emoji: '🎯',
    text: 'Organizar tus ideas y objetivos'
  }, {
    emoji: '💸',
    text: 'Aprender herramientas para generar ganancias seguras sin invertir mucho tiempo'
  }, {
    emoji: '🔭',
    text: 'Aumentar tu claridad y dirección personal'
  }, {
    emoji: '🚀',
    text: 'Avanzar a una versión más preparada de ti mismo'
  }, {
    emoji: '⚡',
    text: 'Construir hábitos que te acerquen a tus metas'
  }, {
    emoji: '💎',
    text: 'Transformar tu forma de pensar sobre el éxito'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-950 to-[#0d0b14]" data-id="element-72">
      <div className="max-w-4xl mx-auto" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-74">
          <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 font-semibold text-sm tracking-wide uppercase mb-6" data-id="element-75">
            ✅ Resultados
          </span>
          <h2 className="text-3xl sm:text-5xl font-extrabold text-white leading-tight" data-id="element-76">
            ¿Qué vas a lograr con este sistema?
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-77">
          {goals.map((goal, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="flex items-center gap-4 p-4 sm:p-5 rounded-2xl bg-white/[0.05] border border-white/10" data-id="element-78">
              <span className="text-2xl flex-shrink-0" data-id="element-79">{goal.emoji}</span>
              <span className="text-slate-200 text-lg font-medium leading-snug" data-id="element-80">
                {goal.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}